import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'shared/routing/withRouter';
import Survey from '../component/Survey';

function SurveyContainer() {
    return (
        <div className="Card-container">
            <Survey />
        </div>
    );
}

const mapStateToProps = (state: { verify: unknown }) => ({
    verify: state.verify,
});

export default compose(connect(mapStateToProps), withRouter)(SurveyContainer);
